import { Component, OnInit } from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {RemarkComponent} from '../../approval-process/remark/remark.component';
import {BlacklistApproveChecklistComponent} from '../../blacklist-process/blacklist-approve-checklist/blacklist-approve-checklist.component';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {TokenStorageService} from '../../shared/service/token-storage.service';
import {ApprovalModel} from '../../shared/dto/approval.model';
import {ReturnRemarkComponent} from '../../approval-process/return-remark/return-remark.component';
import {FwdRemarkComponent} from '../../approval-process/fwd-remark/fwd-remark.component';
import {ApprovalService} from '../../service/approval.service';
import {SuspendService} from '../../shared/service/suspend.service';
import {WorkflowEnum} from '../../shared/enums/workflow.enum';

@Component({
  selector: 'app-reversed-suspend-return-requests',
  templateUrl: './reversed-suspend-return-requests.component.html',
  styleUrls: ['./reversed-suspend-return-requests.component.scss']
})
export class ReversedSuspendReturnRequestsComponent implements OnInit {

  appRefNo: number;
  userName: string;
  userRole: string;
  type: string;
  approvalModel: ApprovalModel = new ApprovalModel();
  public applicntType:string;

  constructor(private route: ActivatedRoute, private tokenStorageService: TokenStorageService,
              private approvalService: ApprovalService, private modalService: NgbModal, private suspendService: SuspendService) {
    this.route.paramMap.subscribe(params => {
      this.appRefNo = +this.decodeBase64(params.get('id'));
      this.applicntType = params.get('type');
    });
  }

  ngOnInit() {
    this.userName=this.tokenStorageService.getUserObjectToken().username;
    this.userRole=this.tokenStorageService.getUserObjectToken().userroleCode;
  }
  decodeBase64(code: string): string {
    return atob(code);
  }

  rejectRequest() {
    this.approvalModel.updatedUser = this.userName;
    this.approvalModel.action = 'Reject';
    this.approvalModel.applicationNo = this.appRefNo;
    this.approvalModel.userRole = this.userRole;
    this.approvalModel.type = this.type;

    const modalRef = this.modalService.open(RemarkComponent,{size: 'lg'});
    let data = {
      model: this.approvalModel,
      appType: this.applicntType
    }

    modalRef.componentInstance.fromParent = data;
    this.approvalService.setModel(this.modalService)
  }

  forwardToDg() {
    this.approvalModel.updatedUser = this.userName;
    this.approvalModel.action = 'FWD_DG';
    this.approvalModel.applicationNo = this.appRefNo;
    this.approvalModel.userRole = this.userRole;
    this.approvalModel.type = this.type;

    const modalRef = this.modalService.open(FwdRemarkComponent,{size: 'lg'});
    let data = {
      model: this.approvalModel,
      appType: this.applicntType
    }

    modalRef.componentInstance.fromParent = data;
    this.approvalService.setModel(this.modalService)
  }

  returnRequest() {
    this.approvalModel.updatedUser = this.userName;
    this.approvalModel.action = 'RETURN';
    this.approvalModel.applicationNo = this.appRefNo;
    this.approvalModel.userRole = this.userRole;
    this.approvalModel.type = this.type;

    const modalRef = this.modalService.open(ReturnRemarkComponent,{size: 'lg'});
    let data = {
      model: this.approvalModel,
      appType: this.applicntType
    }

    modalRef.componentInstance.fromParent = data;
    this.approvalService.setModel(this.modalService);
  }

  approveRequest() {
    this.approvalModel.updatedUser = this.userName;
    this.approvalModel.action = 'APPROVE';
    this.approvalModel.applicationNo = this.appRefNo;
    this.approvalModel.userRole = this.userRole;
    this.approvalModel.type = this.type;
    this.approvalModel.stage = WorkflowEnum.SUSPEND_REVERSED_RETURN;

    const modalRef = this.modalService.open(BlacklistApproveChecklistComponent,{size: 'lg'});
    let data = {
      model: this.approvalModel,
      appType: this.applicntType
    }

    modalRef.componentInstance.fromParent = data;
    this.approvalService.setModel(this.modalService);
  }


}
